"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Read = __importStar(require("./read"));
exports.Read = Read;
const Decode = __importStar(require("./decode"));
exports.Decode = Decode;
//# sourceMappingURL=index.js.map